import Address from '@modules/husleie-framework/src/types/Address.entity';
import { ElectricityProviderData } from '@modules/husleie-framework/src/types/ElectricityProviderData.entity';
import { UpsellStatusEnum } from '@modules/husleie-framework/src/types/Upsell.entity';
import { UpsellElectricity } from '@modules/husleie-framework/src/types/UpsellElectricity.entity';
import { UserTranslationOptions } from '@modules/store/user/types/UserTranslationOptions.entity';

export default class ElectricityUpsellConversionOperations {
  // eslint-disable-next-line no-unused-vars,@typescript-eslint/no-unused-vars
  static apiToInternal(apiUpsell: any, options: UserTranslationOptions): UpsellElectricity {
    const upsell: UpsellElectricity = {
      status: apiUpsell.status ? apiUpsell.status : UpsellStatusEnum.PREORDERED,
      partner: apiUpsell.extra && apiUpsell.extra.partner ? apiUpsell.extra.partner : undefined,
      customer: apiUpsell.extra && apiUpsell.extra.customer ? apiUpsell.extra.customer : undefined,
      buttons: apiUpsell.extra && apiUpsell.extra.buttons ? apiUpsell.extra.buttons : undefined,
    };
    if (apiUpsell.extra && apiUpsell.extra.tariff) {
      upsell.tariff = apiUpsell.extra.tariff;
    }

    return upsell;
  }

  static internalToApi(upsell: UpsellElectricity): any {
    const apiUpsell: any = {
      product: 'electricity_subscription',
      status: upsell.status,
      extra: {
        partner: upsell.partner,
        customer: upsell.customer,
      },
    };

    apiUpsell.extra.tariff = upsell.tariff;

    return apiUpsell;
  }

  static internalTarifDataToApi(amountOfResidents: number, address: Address): any {
    const apiTariff: any = {
      amountOfResidents,
      postalArea: address.postalArea,
      postalCode: address.postalCode,
      street: address.street,
      street2: address.additionalAddress,
    };

    return apiTariff;
  }

  static apiProviderDataToInternal(apiProvider: any): ElectricityProviderData {
    const providerData: ElectricityProviderData = {
      providerName: apiProvider.providerName,
      kwhPrice: apiProvider.kwhPrice,
      savings: apiProvider.savings,
      monthlyPrice: apiProvider.monthlyPrice,
      yearlyPrice: apiProvider.yearlyPrice,
      tariff: apiProvider.tariff,
    };

    return providerData;
  }
}
